import type { JSX } from "react";
import { DialpadIcon, IconButton } from "@/common-ui";
import { useControlsStore } from "../controls.store";

export function ToggleDialpadButton(): JSX.Element {
    const { dialpadOpen, isMuted, toggleDialpadActive } = useControlsStore();

    const isDisabled = isMuted;
    return (
        <IconButton
            active={dialpadOpen}
            analytics={{
                actionId: "ToggleDialpadButton",
            }}
            aria-label="Dialpad"
            data-testid="call-controls-dialpad-toggle"
            onClick={toggleDialpadActive}
            disabled={isDisabled}
            radius="xl"
            size="30"
            tooltip={isDisabled ? "Disabled while muted" : "Dialpad"}
        >
            <DialpadIcon
                height={15}
                stroke={dialpadOpen ? "var(--mantine-color-black)" : "var(--mantine-color-white)"}
            />
        </IconButton>
    );
}
